<template>
    <div class="price-container">
        <p>Prix total : <span style="font-weight:600;">{{totalPrice}} €</span></p>
    </div>
</template>


<script>
    export default {
        name: "PriceManager",

        /*  created() {
              //this.$store.dispatch('calculatePrice');
          }*/
        computed: {               
            
        }
    }
</script>


<style scoped>
    .price-container {
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #4d5152;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    p {
        color: #ffffff;
        margin-bottom: 0;
        padding: 10px;
        font-size: 1.4em;
    }
</style>